export enum NotificationMessages {
  ADDITIONAL_CONSUMABLES = 'Необхідне погодження додаткової обробки поля',
  LOW_RATING = 'Низька оцінка стану посівів',
  EXPIRED_SCOUT_REPORT = 'Запланований огляд не було здійснено',
  LOW_NDVI = 'Низький індекс вегетації',
  ADDITIONAL_SCOUT_REPORT = 'Створено додатковий огляд',
  DISASTERS = 'Стихійні лиха',
  NEW_USER_REGISTRATION = 'Зареєстровано нового користувача',
  NO_USER_FIELD_BIND = 'За полем не закріплено жодного агронома',
  CRITICAL_MALICIOUS = 'Виявлено критичні хвороби/шкідники'
}
